import React, { useEffect } from 'react'
import { Route, Switch } from 'react-router-dom'
import { useLocation } from 'react-router'

import ArtistDashboard from 'components/artist-dashboard/ArtistDashboard'
import ErrorBoundary from 'components/common/ErrorBoundary/ErrorBoundary'
import GenericRoute from 'routing/genericRoute'
import GlobalModal from 'components/common/GlobalModal/GlobalModal'
import Homepage from 'components/root/Homepage/Homepage'
import PasswordRecovery from 'components/password-reset/PasswordRecovery/PasswordRecovery'
import PriorityList from 'components/priority-list/PriorityList/PriorityList'
import RefundPolicy from 'components/refund-policy/RefundPolicy'
import SetPage from 'components/set/SetPage/SetPage'
import Support from 'components/support/Support'
import UserSettings from 'components/user-settings/UserSettings'
import Hub from 'components/hub/Hub'
import EventChat from 'components/event-chat/EventChat'
import EventQA from 'components/event-qa/EventQA'

const RoutesDefinition = () => {
    const location = useLocation()

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [location])

    return (
        <>
            <GlobalModal />
            <ErrorBoundary showModal>
                <Switch>
                    <GenericRoute
                        home
                        nav
                        transparent
                        exact
                        path="/"
                        component={() => {
                            window.location.href = process.env.REACT_APP_COMPANY_WEBSITE_URL
                            return null
                        }}
                    />
                    <GenericRoute home nav transparent exact path="/events" component={Homepage} />
                    <GenericRoute nav transparent exact path="/hub/:seriesId" component={Hub} />
                    <GenericRoute exact path="/set/:showPath" component={SetPage} />
                    <GenericRoute exact path="/set/:showPath/chat" component={EventChat} />
                    <GenericRoute exact path="/set/:showPath/qa" component={EventQA} />
                    <GenericRoute path="/password-reset" component={PasswordRecovery} />
                    <GenericRoute guarded nav dark exact path="/account" component={UserSettings} />
                    <GenericRoute exact path="/priority-list/:artistId" component={PriorityList} />
                    <GenericRoute guarded exact path="/artist/:showId" component={ArtistDashboard} />
                    <GenericRoute nav="absolute" dark exact path="/refund" component={RefundPolicy} />
                    <GenericRoute nav="absolute" dark exact path="/support" component={Support} />
                    <Route component={NotFound} />
                </Switch>
            </ErrorBoundary>
        </>
    )
}

function NotFound() {
    window.location = `${window.location.protocol}//${window.location.host}`
    return null
}

export const Routes = RoutesDefinition
